import React, { useState, MouseEvent, Dispatch, SetStateAction, Fragment } from 'react';

import { Cta } from '../../atoms';
import { makeClassNames } from '../../../utils/styles';
import './general-filter-component.scss';

export interface IGeneralFilterComponent {
  array?: { [key: string]: any }[];
  base?: string;
  filterCriterion?: string;
  dataVariant: string;
  filterList: string[];
  labels: string[];
  setFilterTerm?: Dispatch<SetStateAction<string>>;
  isSeoDriven?: boolean;
  ctaLabel?: string;
  href?: string | null;
}

const classNames = () =>
  makeClassNames({
    filterContainer: 'filter-container',
    filterBtn: 'filter-btn',
    filterCta: 'filter-cta',
  });

const cn = classNames();

const GeneralFilterComponent = ({
  base,
  dataVariant,
  filterList,
  labels = ['Uno', 'Due', 'Tre'],
  setFilterTerm,
  isSeoDriven = false,
  ctaLabel,
  href,
}: IGeneralFilterComponent) => {
  const [activeBtn, setActiveBtn] = useState('0');

  const filtersArray = [base, ...filterList];

  const handleSetFilter = (e: MouseEvent<HTMLButtonElement>) => {
    if (!(e.target instanceof HTMLButtonElement)) {
      return;
    }

    setFilterTerm?.(e.target.dataset.filter!);
    setActiveBtn(e.target.id);
  };

  return (
    <div data-variant={dataVariant} className={cn.filterContainer}>
      {isSeoDriven && href ? (
        <Cta label={ctaLabel} href={href} iconPosition="right" iconSize="xxsmall" className={cn.filterCta}>
          {ctaLabel}
        </Cta>
      ) : (
        <Fragment>
          {filtersArray.map((element, i) => (
            // eslint-disable-next-line react/button-has-type
            <button
              className={cn.filterBtn}
              type="button"
              id={`${i}`}
              data-filter={i === 0 ? base : element}
              data-active={i.toString() === activeBtn}
              key={i}
              onClick={handleSetFilter}
              aria-label={i === 0 ? base : labels[i - 1]}
            >
              {i === 0 ? base : labels[i - 1]}
            </button>
          ))}
        </Fragment>
      )}
    </div>
  );
};

export default GeneralFilterComponent;
